import { MX_DOMAIN_EXTENSION } from '@/constants/domainExtensions'

export const ES_CURRENCY = '€'
export const MX_CURRENCY = '$'
export const PT_CURRENCY = '€'

export function getCurrencyByDomain () {
    return window.location.href.includes(MX_DOMAIN_EXTENSION) ? MX_CURRENCY : ES_CURRENCY
}


// WEBPACK FOOTER //
// ./src/constants/currencies.js